var general_rtlignore_default = {
  "alignLeft": "cDOL4",
  "textWrapNowrap": "dW3iE",
  "alignRight": "GyehU",
  "alignCenter": "SErax",
  "sizeFullWidth": "CC1HG",
  "renderedInTable": "kCHbD",
  "sizeOriginal": "qE7Ti",
  "sizeContent": "c8QuI",
  "sizeSmall": "_5Iy2d",
  "sizeSmallCenter": "TPDxi",
  "flex": "bKiHR"
};
export {
  general_rtlignore_default as default
};
//# sourceMappingURL=general.rtlignore.scss.js.map
